import { ICascadingSetting } from '../types/cascading-settings.types';

interface ICascadingSettingSources {
  assessment?: IAssessment;
  company?: ICompany;
}

// `??`, never `||`: a stored `false` is a deliberate choice, so only an unset value falls through.
export const resolveCascadingSetting = (
  { assessmentField, companyField, fallback }: ICascadingSetting,
  { assessment, company }: ICascadingSettingSources = {},
): boolean => assessment?.[assessmentField] ?? company?.[companyField] ?? fallback;
